<script setup>

const props = defineProps({
    headerClass: {
        type: String,
    },
    footerClass: {
        type: String,
    },
    contentClass: {
        type: String,
    },
    progress: {
        type: Number,
        default: 0
    },
    progressClass: {
        type: String,
    }
    // isOpen: {
    //     type: Boolean,
    //     default: false
    // }
})

</script>

<style lang="scss"></style>

<template>
<div class="absolute top-0 left-0 w-full h-[100vh] z-[70] bg-white">
    <div :class="props.headerClass" v-if="$slots.header" class="relative">
        <div class="h-1 bg-[#9E77ED] absolute bottom-[-3px] transition-all duration-200" :class="props.progressClass"
            :style="`width: ${props.progress || 0}%`"></div>
        <slot name="header"></slot>
    </div>
    <div class="py-[60px] px-5 bg-white h-[calc(100vh-91px)] overflow-y-auto" :class="props.contentClass">
        <slot></slot>
    </div>
    <div :class="props.footerClass" class="bg-white" v-if="$slots.footer">
        <slot name="footer"></slot>
    </div>
</div>
</template>
